export default __webpack_public_path__ + "static/media/chem720.495f5df1.svg";